import React from 'react';
import { PrimaryNavbar } from './primary-navbar.component';
import { NavProvider } from '../nav.context';

const PractitionerContainer = () => {
  return (
    <NavProvider>
      <PrimaryNavbar />
    </NavProvider>
  );
};

export default PractitionerContainer;
